/* eslint-disable */
import React, { useState } from "react";
import axios from "axios";
import Table from "components/Table/index";
import H5 from "components/H5";
import LoadingBox from "components/LoadingBox.js";
import moment from "moment";
import _ from "lodash";
import styled from "styled-components";
import Badge from "components/Badge";
import NoData from "./NoData";
import "./generateReport.scss";
import authSvc from "services/authSvc";

// library
import ReactPaginate from "react-paginate";

const Div = styled.div`
  @media only screen and (max-width: 1024px) {
    display: none !important;
  }
`;

const SetLoadingBox = (count) => {
  let i;
  const data = [];
  for (i = 0; i < count; i += 1) {
    data.push(
      <tr>
        <td>
          <LoadingBox height={10} borderRadius={8} />
        </td>
        <td>
          <LoadingBox height={10} borderRadius={8} />
        </td>
        <td>
          <LoadingBox height={10} borderRadius={8} />
        </td>
        <td>
          <LoadingBox height={10} borderRadius={8} />
        </td>
        <td>
          <LoadingBox height={10} borderRadius={8} />
        </td>
        <td>
          <LoadingBox height={10} borderRadius={8} />
        </td>
        <td>
          <LoadingBox height={10} borderRadius={8} />
        </td>
      </tr>
    );
  }
  return data;
};

const TableData = (props) => {
  const [searchCriteria, setSearchCriteria] = useState({});
  const { isDataUser, isLoadingGetList, isPagination, changeCriteria } = props;

  const isNoData = isDataUser.length <= 0 && !isLoadingGetList;

  function handlePageClick(e) {
    const selectedPage = e.selected + 1;
    let data = searchCriteria;
    data.page = selectedPage;
    setSearchCriteria(searchCriteria);
    changeCriteria(searchCriteria);
  }

  async function onDownload(value) {
    // const response = await axios.get(`${value}`, {
    //   headers: {
    //     'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjVlZjQzZWNhZDZlMDExMjk4NWM2OTJkOSIsImVtYWlsIjoiZnJlemFudWdyYWhhNDA0QGdtYWlsLmNvbSIsIm5hbWUiOiJGcmV6YSBOdWdyYWhhIiwiZXh0ZXJuYWxfcGhvdG9fdXJsIjoiaHR0cHM6Ly9zdG9yYWdlLm9jYXRlbGtvbS5jby5pZC9hZ2VudHMvcHJvZmlsZV9pbWFnZS84ZDhjZWZiYmU1YmQzY2UxMDg1MGNkYTFhZTcyNjFiMS5qcGVnIiwiYXBwbGljYXRpb24iOiI1ZWQwODIzOTYzYjI2NDAxYTIyOWQ5ZmYiLCJyb2xlIjoic3VwZXJ2aXNvciIsImlhdCI6MTY3OTk4NDUzNX0.1UveX-VDJtZuf2kOSRBHTK6POzEhsGFS8Fvy3DOeNQI`,
    //   },
    // });
    // window.open(response?.data?.data?.download_url);
    window.open(value);
  }

  return (
    <Div className="d-flex flex-column pb-3 position-relative">
      <Table className={`${isNoData && `margin-bottom-40`}`}>
        <thead>
          <tr>
            <th className="col-sm-1 ">Report Title</th>
            <th className="col-sm-1 ">Channel</th>
            <th className="col-sm-1 ">Create At</th>
            <th className="col-sm-1 text-center">Total Data</th>
            <th className="col-sm-1 ">Range Date</th>
            <th className="col-sm-1 text-center">Status</th>
            <th className="col-sm-1 ">Action</th>
          </tr>
        </thead>
        <tbody>
          {!isNoData && (
            <>
              {isLoadingGetList && SetLoadingBox(10)}
              {!isLoadingGetList &&
                isDataUser.map((val) => {
                  return (
                    <tr key={val._id}>
                      <td className="">{val.name ? val.name : "-"}</td>
                      <td className="">{val.channel}</td>
                      <td className="">{moment(val.created_at).format("DD-MM-YYYY hh:mm:ss A")}</td>
                      <td className="text-center">
                        {val.data_processed !== undefined ? val.data_processed : "-"}
                      </td>
                      <td className="">{val.start_date} - {val.end_date}</td>
                      {/* <td className="">{moment(val.start_date).format("DD-MM-YYYY")} - {moment(val.end_date).format("DD-MM-YYYY")}</td> */}
                      
                      <td className={`text-center tooltipViewerMode`}>
                        {val.status === "read" && (
                          <Badge
                            // title={val.status}
                            textColor="#219653"
                            backgroundColor="#F0FFF6"
                            fontSize="12px"
                            style={{ width: "120px", textAlign: "center" }}
                          >
                            {val.status}
                          </Badge>
                        )}
                        {val.status === "in-queue" && (
                          <Badge
                            // title={val.status}
                            textColor="#FF8B00"
                            backgroundColor="#FFFAE6;"
                            fontSize="12px"
                            style={{ width: "120px", textAlign: "center" }}
                          >
                            Preparation
                            <div
                              className={`${
                                val?.additional_info?.reason ? "tooltipTextViewerMode" : "d-none"
                              }`}
                            >
                              <span className="tooltiptext">
                                {val?.additional_info?.reason ? val?.additional_info?.reason : "~"}
                              </span>
                            </div>
                          </Badge>
                        )}
                        {val.status === "onprogress" || val.status === 'processing' && (
                          <Badge
                            // title={val.status}
                            textColor="#FF8B00"
                            backgroundColor="#FFFAE6;"
                            fontSize="12px"
                            style={{ width: "120px", textAlign: "center" }}
                          >
                            Processing
                            <div
                              className={`${
                                val?.additional_info?.reason ? "tooltipTextViewerMode" : "d-none"
                              }`}
                            >
                              <span className="tooltiptext">
                                {val?.additional_info?.reason ? val?.additional_info?.reason : "~"}
                              </span>
                            </div>
                          </Badge>
                        )}
                        {val.status === "failed" && (
                          <Badge
                            // title={val.status}
                            textColor="#EB5757"
                            backgroundColor="#FFE9F0"
                            fontSize="12px"
                            style={{ width: "120px", textAlign: "center" }}
                          >
                            {val.status}
                            <div
                              className={`${
                                val?.additional_info?.reason ? "tooltipTextViewerMode" : "d-none"
                              }`}
                            >
                              <span className="tooltiptext">
                                {val?.additional_info?.reason ? val?.additional_info?.reason : "~"}
                              </span>
                            </div>
                          </Badge>
                        )}
                        {val.status === "done" && (
                          <Badge
                            // title={val.status}
                            textColor="#219653"
                            backgroundColor="#F0FFF6"
                            fontSize="12px"
                            style={{ width: "120px", textAlign: "center" }}
                          >
                            {val.status}
                            <div
                              className={`${
                                val?.additional_info?.reason ? "tooltipTextViewerMode" : "d-none"
                              }`}
                            >
                              <span className="tooltiptext">
                                {val?.additional_info?.reason ? val?.additional_info?.reason : "~"}
                              </span>
                            </div>
                          </Badge>
                        )}
                      </td>
                      <td>
                        <div>
                          <a
                            onClick={() => onDownload(val.url)}
                            className={`${
                              val.status === "done"
                                ? "download-report-active"
                                : "download-report-inactive disabled"
                            }`}
                          >
                            Download
                          </a>
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </>
          )}
        </tbody>
      </Table>
      {!isNoData && (
        <div className="selector-none mt-2 text-sm flex-1 d-flex items-center justify-content-between align-items-center">
          <div className="d-flex flex-row btn-total-data">
            <div className="">Total : {isPagination.total_all}</div>
          </div>
          <div className="flex flex-row flex-wrap">
            <ReactPaginate
              previousLabel="&#10094;"
              nextLabel="&#10095;"
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={isPagination.pages}
              marginPagesDisplayed={1}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              forcePage={isPagination.page ? isPagination.page - 1 : ""}
              containerClassName={"pagination"}
              subContainerClassName={"pages pagination"}
              activeClassName={"active"}
            />
          </div>
        </div>
      )}
      {isNoData && <NoData />}
    </Div>
  );
};

export default TableData;
